<template>
  <div ref="root" class="preference-dropdown" :class="{ open: open }">
    <button
      class="preference-trigger"
      type="button"
      :aria-label="ariaLabel"
      :aria-expanded="open ? 'true' : 'false'"
      @click="open = !open"
    >
      <span v-if="selected.meta" class="preference-meta">{{ selected.meta }}</span>
      <img v-if="selected.flagSrc" class="preference-flag" :src="selected.flagSrc" alt="" aria-hidden="true">
      <span v-else-if="selected.flag" class="preference-flag" aria-hidden="true">{{ selected.flag }}</span>
      <span class="preference-value">{{ selected.displayLabel || selected.label }}</span>
      <font-awesome-icon class="preference-chevron" :icon="chevronIcon" />
    </button>
    <div v-if="open" class="preference-menu" role="menu">
      <button
        v-for="option in options"
        :key="option.value"
        class="preference-option"
        :class="{ active: option.value === value }"
        type="button"
        role="menuitem"
        @click="select(option.value)"
      >
        <span v-if="option.meta" class="preference-meta">{{ option.meta }}</span>
        <img v-if="option.flagSrc" class="preference-flag" :src="option.flagSrc" alt="" aria-hidden="true">
        <span v-else-if="option.flag" class="preference-flag" aria-hidden="true">{{ option.flag }}</span>
        <span>{{ option.label }}</span>
        <font-awesome-icon v-if="option.value === value" class="preference-check" :icon="checkIcon" />
      </button>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons/faChevronDown";
import { faCheck } from "@fortawesome/free-solid-svg-icons/faCheck";

export default {
  components: { FontAwesomeIcon },
  props: {
    ariaLabel: { type: String, default: "Preference" },
    value: { type: String, default: "" },
    options: { type: Array, default: () => [] },
  },
  data() {
    return {
      open: false,
      chevronIcon: faChevronDown,
      checkIcon: faCheck,
    };
  },
  computed: {
    selected() {
      return this.options.find((option) => option.value === this.value) || this.options[0] || { label: this.value, value: this.value };
    },
  },
  mounted() {
    document.addEventListener("click", this.closeOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeOutside);
  },
  methods: {
    select(value) {
      this.$emit("input", value);
      this.$emit("change", value);
      this.open = false;
    },
    closeOutside(event) {
      if (this.open && this.$refs.root && !this.$refs.root.contains(event.target)) this.open = false;
    },
  },
};
</script>

<style scoped>
.preference-dropdown { position:relative; }
.preference-trigger,
.preference-option {
  border:0;
  background:#fff;
  color:#555;
  font:inherit;
}
.preference-trigger {
  display:flex;
  min-height:30px;
  align-items:center;
  gap:7px;
  padding:3px 6px;
  cursor:pointer;
  border-radius:var(--radius-sm);
}
.preference-trigger:hover,.open .preference-trigger{background:#f7f8fa;color:var(--ink)}
.preference-chevron { width:9px; transition:transform .16s ease; }
.open .preference-chevron { transform:rotate(180deg); }
.preference-menu {
  position:absolute;
  top:calc(100% + 7px);
  left:0;
  z-index:80;
  width:max-content;
  min-width:205px;
  padding:6px;
  border:1px solid #eceef2;
  border-radius:var(--radius-md);
  background:#fff;
  box-shadow:0 14px 38px rgba(22,22,22,.14);
  transform-origin:top left;
  animation:menu-in .16s var(--ease);
}
.preference-option {
  display:grid;
  width:100%;
  grid-template-columns:34px minmax(0,1fr) 16px;
  align-items:center;
  gap:8px;
  padding:9px 10px;
  border-radius:var(--radius-sm);
  text-align:left;
  cursor:pointer;
}
.preference-option:hover,
.preference-option.active { background:#fff2ef; color:var(--brand); }
.preference-meta {
  display:inline-flex;
  min-width:30px;
  height:20px;
  align-items:center;
  justify-content:center;
  border:1px solid #eceef2;
  border-radius:3px;
  color:#777;
  font-size:10px;
  font-weight:700;
  line-height:1;
}
.preference-check { width:11px; justify-self:end; }
.preference-flag { display:block; width:20px; height:14px; border:1px solid #eceef2; border-radius:2px; object-fit:cover; font-size:16px; line-height:1; }
.preference-option:not(:has(.preference-meta)):not(:has(.preference-flag)) { grid-template-columns:minmax(0,1fr) 16px; }
@keyframes menu-in{from{opacity:0;transform:translateY(-5px) scale(.98)}to{opacity:1;transform:none}}
</style>
